function asciiToArray(string) {
  return string.split("");
}
export {
  asciiToArray as default
};
